// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__1udJA","sec":"Group_sec__HL3Gp"};